"use client";
//? Library Imports ------------------------------------------------------------>
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { Col, Row, Space, Image, Layout, message, Typography } from "antd";

//? Modules -------------------------------------------------------------------->
import Wallet from "./Modules/Wallet/Wallet";
import AddressBook from "./Modules/AddressBook/AddressBook";
import EditProfile from "./Modules/EditProfile/EditProfile";
import RewardPoints from "./Modules/RewardPoints/RewardPoints";
import WishlistModule from "./Modules/WishlistModule/WishlistModule";
import DashboardModule from "./Modules/DashboardModule/DashboardModule";
import OrdersListingModule from "./Modules/OrdersListingModule/OrdersListingModule";
// import AccountsHeaderMobile from "../Headers/AccountsHeaderMobile/AccountsHeaderMobile";
// import DynamicButton from "@/components/Shared/Buttons/DynamicButton/DynamicButton";

//? Assets --------------------------------------------------------------------->
import "./AccountsPageMobile.scss";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
import AccountStatus, { customerLogout } from "@/functions/Cookies/Cookies";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;
const { Content, Sider } = Layout;

export default function AccountsPageMobile({ userAgent }) {
  //? Hooks ---------------------------------------------------------------------->
  const router = useRouter();
  const dispatch = useDispatch();
  const {
    loggedIn,
    comverse_customer_id,
    comverse_customer_email,
    comverse_customer_token,
  } = AccountStatus();

  //? Redux States --------------------------------------------------------------->
  const comverse_customer_name = useSelector(
    (state) => state.accountSlice?.comverse_customer_name
  );
  const ActiveMenu = useSelector((state) => state.accountSlice?.activeMenu);
  // const comverse_customer_token = useSelector(
  //   (state) => state.accountSlice?.comverse_customer_token
  // );
  // const loggedIn = useSelector((state) => state.accountSlice.loggedIn);

  //? States --------------------------------------------------------------------->
  const [Loading, setLoading] = useState(true);
  // const [ActiveMenu, setActiveMenu] = useState("dashboard");

  //? Orders Listiing States ----------------------------------------------------->
  const [OrdersList, setOrdersList] = useState([]);
  const [OrdersDetail, setOrdersDetail] = useState();

  //? Wishlist Module States ----------------------------------------------------->
  const [WishList, setWishList] = useState([]);
  const [WishlistDetail, setWishlistDetail] = useState();

  //? Functions ------------------------------------------------------------------>
  const logOut = useCallback(() => {
    customerLogout();
    dispatch(logoutReducer());
    router.push("/");
  }, [dispatch, router]);

  const fetchOrderDetails = useCallback(
    async (pageNo) => {
      setLoading(true);

      let urlToHit = pageNo
        ? `/storefront/customer_order_list?page=${pageNo}&limit=${6}&storefront=23`
        : `/storefront/customer_order_list?storefront=23`;

      const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + urlToHit, {
        headers: {
          "Content-Type": "application/json",
          Authorization: comverse_customer_token,
        },
      });

      const OrdersDetail = await res?.json();

      if (
        OrdersDetail?.detail === "Invalid auth token" ||
        OrdersDetail?.detail === "Session Expired, Please login your account"
      ) {
        logOut();
        // message.error("Session Expired");
      } else if (!res.ok) {
        throw new Error("Accounts Api Failed!");
      }

      if (pageNo) {
        // setOrdersList((prevOrders) => [
        //   ...prevOrders,
        //   ...OrdersDetail?.results,
        // ]);
        setOrdersList(OrdersDetail?.results);
        setLoading(false);
      } else {
        setOrdersDetail(OrdersDetail);
        setOrdersList(OrdersDetail?.results);
        setLoading(false);
      }

      return OrdersDetail;
    },
    [comverse_customer_token, logOut]
  );

  const fetchWishlistDetails = useCallback(
    async (pageNo) => {
      setLoading(true);

      let urlToHit = pageNo
        ? `/storefront/wishlist_list?page=${pageNo}&limit=${6}&storefront=23`
        : `/storefront/wishlist_list?limit=${6}&storefront=23`;

      const res = await fetch(process.env.NEXT_PUBLIC_BACKEND + urlToHit, {
        headers: {
          "Content-Type": "application/json",
          Authorization: comverse_customer_token,
        },
      });

      const WishlistDetail = await res?.json();

      if (
        WishlistDetail?.detail === "Invalid auth token" ||
        WishlistDetail?.detail === "Session Expired, Please login your account"
      ) {
        logOut();
        // message.error("Session Expired");
      } else if (!res.ok) {
        throw new Error("Accounts Api Failed!");
      }

      if (pageNo) {
        // setWishList((prevList) => [...prevList, ...WishlistDetail?.results]);
        setWishList(WishlistDetail?.results);
        setLoading(false);
      } else {
        setWishlistDetail(WishlistDetail);
        setWishList(WishlistDetail?.results);
        setLoading(false);
      }

      return WishlistDetail;
    },
    [comverse_customer_token, logOut]
  );

  //? Life Cycles ---------------------------------------------------------------->

  useEffect(() => {}, [ActiveMenu]);

  return (
    <>
      {loggedIn
        ? loggedIn && (
            <Row
              className="AccountsPageMobile marginBottom30"
              style={{ overflow: "hidden", width: "100%" }}
            >
              <Col span={24}>
                <Layout className="site-layout-background">
                  <Content>
                    {ActiveMenu === "dashboard" ? (
                      <Col>
                        <DashboardModule
                          Loading={Loading}
                          userAgent={userAgent}
                          OrdersDetail={OrdersDetail}
                        />
                      </Col>
                    ) : ActiveMenu === "orders" ? (
                      <Col>
                        <OrdersListingModule
                          Loading={Loading}
                          OrdersList={OrdersList}
                          OrdersDetail={OrdersDetail}
                          fetchOrderDetails={fetchOrderDetails}
                        />
                      </Col>
                    ) : ActiveMenu === "wishlist" ? (
                      <Col>
                        <WishlistModule
                          userAgent={userAgent}
                          Loading={Loading}
                          WishList={WishList}
                          WishlistDetail={WishlistDetail}
                          fetchWishlistDetails={fetchWishlistDetails}
                        />
                      </Col>
                    ) : ActiveMenu === "points" ? (
                      <Col>
                        <RewardPoints Loading={Loading} />
                      </Col>
                    ) : ActiveMenu === "wallet" ? (
                      <Col>
                        <Wallet Loading={Loading} />
                      </Col>
                    ) : ActiveMenu === "faq" ? (
                      <Col>FAQs</Col>
                    ) : ActiveMenu === "about" ? (
                      <Col>About Us</Col>
                    ) : ActiveMenu === "terms" ? (
                      <Col>Terms & Conditions</Col>
                    ) : ActiveMenu === "privacy" ? (
                      <Col>Privacy Policy</Col>
                    ) : ActiveMenu === "address" ? (
                      <Col>
                        <AddressBook Loading={Loading} />
                      </Col>
                    ) : ActiveMenu === "edit" ? (
                      <Col>
                        <EditProfile />
                      </Col>
                    ) : null}
                  </Content>
                </Layout>
              </Col>
            </Row>
          )
        : router.push("/")}
    </>
  );
}
